<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseBubble from 'next/message/bubbles/Base.vue';
import Icon from 'next/icon/Icon.vue';
import FormattedContent from './FormattedContent.vue';
import AttachmentChips from 'next/message/chips/AttachmentChips.vue';
import { MESSAGE_TYPES } from '../../constants';
import { useMessageContext } from '../../provider.js';
import { useTranslations } from 'dashboard/composables/useTranslations';

const { content, attachments, contentAttributes, messageType } =
  useMessageContext();

const { t } = useI18n();

const { hasTranslations, translationContent, translationLocale } =
  useTranslations(contentAttributes);

const isTemplate = computed(() => {
  return messageType.value === MESSAGE_TYPES.TEMPLATE;
});

const isEmpty = computed(() => {
  return !content.value && !attachments.value?.length;
});

// BonBoZ: nhan LUON noi ro dich sang tieng gi.
//
// `translations` la mot bang nhieu thu tieng; bo chon co the roi vao thu tieng
// KHONG phai cua nguoi dang truc (xem `selectTranslationLocale`). Nhan tron
// "Dich tu dong" trong truong hop do la noi thieu mot nua.
const nhanDich = computed(() =>
  translationLocale.value
    ? t('BONBOZ.DICH.NGON_NGU', { ma: translationLocale.value })
    : t('BONBOZ.DICH.NHAN')
);
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="text">
    <div class="gap-3 flex flex-col">
      <span v-if="isEmpty" class="text-n-slate-11">
        {{ $t('CONVERSATION.NO_CONTENT') }}
      </span>
      <FormattedContent v-if="content" :content="content" />
      <!-- BonBoZ: ban dich GHEP DUOI ban goc, khong thay the no.
           Ban goc cua Chatwoot doi chu trong bong bong thanh ban dich va de mot
           dong link xam "Xem ban goc" o day. Hai cho hong:
           - bong bong la BAN GHI nhung gi khach that su nhan; doi chu di la
             khong con dau hieu nao cho biet dang doc chu may dich, dich sai mot
             cho la nguoi truc tuong khach noi vay that;
           - muon doi chieu thi phai bam qua bam lai tung tin mot.
           Ghep duoi thi ca hai cung nam do, duong ke va nhan lam ranh gioi. Tin
           chat thuong ngan nen cai gia phai tra la vai chuc pixel.
           `border-n-slate-12/15`: bong bong khach nen trang, bong bong minh nen
           xanh la, ghi chu rieng nen vang — mot net ke mo theo mau chu hop voi
           ca ba, va tu dao lai o theme toi.
           DA THU `border-current/15` va KHONG chay: Tailwind 3 khong gan duoc do
           mo cho `currentColor` (phai la mau khai bao co cho `<alpha-value>`),
           nen lop do khong duoc sinh ra — vien roi ve bang mau mac dinh cua
           preflight, sai mau ma khong bao loi gi. -->
      <div
        v-if="hasTranslations && translationContent"
        class="flex flex-col gap-1 pt-2.5 border-t border-n-slate-12/15"
      >
        <span class="inline-flex gap-1 items-center text-xs text-n-slate-11">
          <Icon icon="i-lucide-languages" class="size-3.5 shrink-0" />
          {{ nhanDich }}
        </span>
        <FormattedContent :content="translationContent" />
      </div>
      <AttachmentChips :attachments="attachments" class="gap-2" />
      <template v-if="isTemplate">
        <div
          v-if="contentAttributes.submittedEmail"
          class="px-2 py-1 rounded-lg bg-n-alpha-3"
        >
          {{ contentAttributes.submittedEmail }}
        </div>
      </template>
    </div>
  </BaseBubble>
</template>

<style>
p:last-child {
  margin-bottom: 0;
}
</style>
